export default __webpack_public_path__ + "static/media/image-chat-whatsapp-not-available.621f8565.svg";